import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function importDataSources({
  accountId,
  dataSourceId,
  files,
}: {
  accountId: string;
  dataSourceId: string;
  files: File[];
}) {
  const formData = new FormData();
  files.forEach((file) => formData.append("files", file));

  try {
    await axios.post(
      `/accounts/${accountId}/wallets/import?dataSourceId=${encodeURIComponent(
        dataSourceId,
      )}`,
      formData,
    );
  } catch (error) {
    throwSylaApiError(error);
  }
}
